module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/png/todo_lv-594c215369c74222770bae5b264bba25.png";